import dateFormatter from '@/services/formatter_services/date-formatter';

const HOLIDAYS_WIDGETS = Object.freeze({
  HOLIDAYS_WIDGETS: [
    {
      id: 'holidays',
      path: 'holidays',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Common.start',
          value: 'startDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Common.end',
          value: 'endDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        { text: 'Common.employee', value: 'employeeName' },
        {
          text: 'Common.type',
          value: 'attendanceType'
        },
        { text: 'Common.status', value: 'status' }
      ],
      type: 'TABLE',
      moduleId: 'holidays',
      withRouterActionLink: true
    },
    {
      id: 'holidaysAmount',
      path: 'holidays',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'holidays'
    }
  ],
  HOLIDAYS_OVERVIEW_WIDGETS: [
    {
      id: 'holidaysOverview',
      path: 'holidayoverviews',
      pathParameter: new Date().getFullYear(),
      type: 'KEY_VALUE',
      moduleId: 'holidayEntitlement'
    }
  ],
  DEPUTIES_WIDGETS: [
    {
      id: 'holidaydeputiesOverview',
      path: 'holidaydeputies',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        { text: 'Common.employee', value: 'employee' },
        {
          text: 'Dashboard.widgets.holidaydeputiesOverview.headers.deputy',
          value: 'deputy'
        },
        {
          text: 'Common.start',
          value: 'startDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Ccommon.endDate',
          value: 'endDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Dashboard.widgets.holidaydeputiesOverview.headers.requestedAt',
          value: 'requestedAt',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        { text: 'Common.status', value: 'status' }
      ],
      type: 'TABLE',
      moduleId: 'deputies',
      withRouterActionLink: true
    },
    {
      id: 'holidaydeputies',
      path: 'holidaydeputies',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'deputies'
    }
  ],
  APPROVALS_MODULE: [
    {
      id: 'holidayapprovalsOverview',
      path: 'holidayapprovals',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        { text: 'Common.type', value: 'attendanceType' },
        {
          text: 'Common.start',
          value: 'startDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Common.end',
          value: 'endDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Common.employee',
          value: 'employee'
        },
        { text: 'Common.status', value: 'status' }
      ],
      type: 'TABLE',
      moduleId: 'approval',
      withRouterActionLink: true
    },
    {
      id: 'holidayapprovals',
      path: 'holidayapprovals',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'approval'
    }
  ]
});
export default HOLIDAYS_WIDGETS;
